module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.socialreason.name) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.socialreason.trm_change.length) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No hay Elementos seleccionados")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.socialreason.trm_change), function(item, index) {
    return _c('tr', {
      key: ("" + item + index + "-budget-item"),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.socialreason.money_code) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.change) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.month) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.year) + "\n                  ")])])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("MONEDA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("1 DOLAR EQUIVALE A")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("MES")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("AÑO")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb9ec92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/social-reasons/TrmChangeHistoryModal.vue
// module id = 409
// module chunks = 1